module.exports = __webpack_public_path__ + "img/materials-and-equipments-transfer.e468630f.svg";